<template>
    <crud-base
      :url="url"
      :columns="columns"
      :onDelete="() => {}"
      :onUpdate="() => {}"
      :onStore="() => {}"
      :enableSearch="true"
      :checkAlerts="true"
      primaryKey="id"
    />
</template>

<script>
import CrudBase from "../../../../components/crud/CrudBase.vue";
export default {
  name: "OrigemTicket",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/sac/origem-ticket",
      columns: [
        { label: "ID", field: "id", sortable: false },
        { label: "DESCRIÇÃO", field: "descricao", sortable: false },
      ],
    };
  },
};
</script>
